module.exports = __webpack_public_path__ + "static/aerial-views-xvi-caefc0c5cbfa3bdbc3c69f179e3d7012.jpg";